<template>

<div class="col-md-6 col-md-offset-3">

    <div>


        <h2><strong>Sign In</strong></h2>
 

          <div class="block-heading">
              <h4>Sign in with a valid email and password</h4>
            <br>


            <form id="form" class="clean" data-toggle="validator" v-on:submit.prevent="signIn">
          
              <div class="form-group">
                <div class="input-group">
                  <span class="input-group-addon"><i class="glyphicon glyphicon-envelope"></i></span>
                <input type="email" v-model="email" class="form-control" id="inputEmail" placeholder="Email" data-error="Sorry, that email address is invalid" required >
                </div>
                <div class="help-block with-errors"></div>
              </div>

                <div class="form-group">
                <div class="input-group">
                  <span class="input-group-addon"><i class="glyphicon glyphicon-option-horizontal"></i></span>
                <input type="password" v-model="password" class="form-control" id="inputPassword" placeholder="Password" data-error="Sorry, incorrect password" required >
                </div>
                <div class="help-block with-errors"></div>
              </div>
                <small>Forgot your password? Insert your email and <a v-on:click.prevent="resetpassword" style="cursor: pointer;"><b>click here</b></a></small>
                <br/>
                <small>No account? <router-link to="/Register" style="cursor: pointer;"><b>Register</b></router-link></small>
                

              <br/>
              <br/>
            <!--<input type="submit" class="btn btn-primary" value="Sign In">-->
            <button type="submit" class="btn btn-primary" id="load" data-loading-text="<i class='fa fa-spinner fa-spin '></i> Signing ...">Sign in</button>
            </form>


      </div>
    </div>
</div>


</template>

<script>
import Firebase from "firebase";

export default {
  name: "Login",

  data: function() {
    return {
      email: "",
      password: ""
    };
  },

  mounted() {
    $(document).ready(function() {
      $("#inputEmail").on("change keyup paste", function() {
        $(this).val(
          $(this)
            .val()
            .toLowerCase()
        );
      });
    });

    $("form").validator({
      delay: 200,
      // allows html inside the error messages
      html: false,
      // disable submit button if there's invalid form
      disable: true,
      focus: true,
      // define your custom validation rules
      custom: {},
      // default errof messages
      errors: {
        match: "Does not match",
        minlength: "Not long enough"
      },

      feedback: {
        success: "glyphicon-ok",
        error: "glyphicon-remove"
      }
    });

   $(".btn").on("click", function() {
      var $this = $(this);
      $this.button("loading");
      setTimeout(function() {
        $this.button("reset");
      }, 6000);
    });



  },

  methods: {
    // pusho il recordsul db
    /*
    signIn: function() {
      //alert(this.email);
      Firebase.auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          if (user.emailVerified) {
            location.reload();
          } else {
            this.logOut();
          }
        })
        .catch(err => alert(error));
    }
    */
    signIn: function() {
      Firebase.auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(function(user) {
          if (user.emailVerified) {
            toastr.success("Ok! Approving credentials!");
            setTimeout(function() {
              location.reload();
            }, 2000);
          } else {
            toastr.error("Your email has not been Authenticated");
            $("#inputEmail").val("");
            $("#inputPassword").val("");
            this.logOut();
          }

          // Handle successful login
        })
        .catch(function(error) {
          //alert(error)
          toastr.error("Invalid username or password");
          $("#inputEmail").val("");
          $("#inputPassword").val("");
          // Failed to login, some error occurred.
        });
    },
    resetpassword: function() {
      var emailreset = $("#inputEmail").val();
      Firebase.auth()
        .sendPasswordResetEmail(emailreset)
        .then(function() {
          toastr.success("Resending credentials!");
          setTimeout(function() {
            location.reload();
          }, 2000);
        })
        .catch(function(error) {
          toastr.error("Error. Insert a valid email inside the Email field");
        });
    },

    logOut: function() {
      Firebase.auth()
        .signOut()
        .then(() => {
          this.email = "";
          this.password = "";
          //toastr.warning("Your email has not been Authenticated.");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Login.vue